import { createContext, useContext } from "react";
import { ProjectInfo } from "./Detail";
import { Action, EventCallbackParams, MockupObject } from "./MockupEditor";

interface DetailObj {
  project: ProjectInfo,
  imageEditType: number,
  setImageEditType: (type: number) => void,
  modelEditType: number,
  setModelEditType: (type: number) => void,
  isSelectedMore : boolean,
  checkedElementData: MockupObject | undefined,
  setCheckedElementData: (data: MockupObject) => void,
  editorCallbackData: EventCallbackParams | undefined,
  editorAction : Action | undefined,
  triggerEditorAction: (action: Action) => void
}
export const DetailContext = createContext<DetailObj|null>(null);

export function useDetailContext() : DetailObj | null{
  return useContext(DetailContext);
}

export default function DetailContextProvider(props: {children: any, detail: DetailObj}) {
  const {children, detail} = props ;

  return (
    <DetailContext.Provider value={detail}>
      {children}
    </DetailContext.Provider>
  )
}